/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-25 16:33:51
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-07 21:15:05
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelEditorMaintenancePage/index.tsx
 */
/**
 *  Header component for sales channel layout.
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */
import React from 'react';

import { Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { dispatch } from 'src/store';

import PageWrapper from '../../../constrains/SalesChannelPreviewPageComponents/PageWrapper/PageWrapper';
import RightConfigWrapper from '../../../constrains/SalesChannelPreviewPageComponents/RightConfigWrapper';

import { convertDataFromReduxToServer } from './tools';

// import Preview from './Preview';
import SalesChannelHOC from 'src/constrains/SalesChannelHOC/SalesChannelHOC';
import { EnumMultiLanguageType } from 'src/constrains/SalesChannelMultiLanguageSelect';
import CloneButton from 'src/pages/SalesCannelVersion/SalesChannelEditorMaintenancePage/CloneButton';
import RouteBlock from 'src/pages/SalesChannelContentEditor/SalesChannelEditorHomepage/RouteBlock';
import { modal } from 'src/utils/Modal';
import BasicPageHOC from './BasicPageHOC';
import Config from './Config';
import Header, { Right } from './Header';
import Preview from './Preview';
import Text from './Text';
import {
  getHasModified,
  getLoaded,
  getLoading,
  getSalesChannelContent,
  getSalesChannelName,
  getState,
  getTranslationState,
  request_getMaintenancePage,
  request_submit,
  validation,
  translateMaintenancePage,
} from './slice';
import { DEFAULT_MULTI_LANGUAGE_PARAMS } from '@/src/types/server/params';
//import styles from './style.module.less';
import PreviewContainer, {
  PreviewStyleSwitch,
} from '@/src/constrains/SalesChannelPreviewPageComponents/PreviewContainer';
import CollapseIcon from 'src/constrains/SalesChannelPreviewPageComponents/PageWrapper/Components/CollapseIcon';
import { PreviewWrapper } from 'src/constrains/SalesChannelPreviewPageComponents/PreviewContainer';
import { useI18n } from 'src/hooks/useRouterChange';
import { permissions } from 'src/pages/SalesCannelVersion/SalesChannelEditorMaintenancePage/tools';
import { i18nGet } from 'src/tools/tools';
import { EPreviewSize, WebSiteSubType } from 'src/types/common/SalesChannel';
import TranslationTip from 'src/constrains/SalesChannelAITranslation/TranslationTip';

interface IParams {
  uuid: string;
}

function SalesChangeEditorMaintenancePage(props) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    hasModified,
    isOnPrimaryLanguage,
    loaded,
    submitData: submit,
    currentStyle,
    currentSize,
  } = props;
  const [collapsed, setCollapsed] = React.useState(false);

  const _h = useHistory();

  const _d = useDispatch();

  const _params: IParams = useParams();

  const loading = useSelector(getLoading());

  const { uuid } = _params;

  const { edit_maintenance_page } = permissions(uuid);
  // console.log('view_maintenance_page', view_maintenance_page);

  React.useEffect(() => {
    // _d(
    //   request_getMaintenancePage({
    //     uuid: contentUuid,
    //   }),
    // );
  }, []);
  const {
    translationEnabled,
    translationLoading,
    uuid: _uuid,
  } = useSelector(getTranslationState());
  console.log('_uuid', _uuid);

  const multiLanguageParams = DEFAULT_MULTI_LANGUAGE_PARAMS;

  const handleOnTranslate = (translationEnabled) => {
    _d(
      translateMaintenancePage({
        uuid: _uuid,
        translationEnabled,
        multiLanguageParams,
      }),
    );
  };
  const Ele = React.useMemo(() => {
    if (loaded) {
      if (currentStyle === WebSiteSubType.NativeMobile) {
        if (isOnPrimaryLanguage) {
          return <Config saleChannelUuid={uuid} />;
        } else {
          return (
            <React.Fragment>
              <CloneButton disabled={translationEnabled} />
              <Config saleChannelUuid={uuid} disabled={translationEnabled} />
            </React.Fragment>
          );
        }
      }
      if (currentStyle === WebSiteSubType.ResponsivePage) {
        const isConvertible =
          currentSize === EPreviewSize.MOBILE ||
          currentSize === EPreviewSize.TABLET;
        if (isOnPrimaryLanguage) {
          return (
            <React.Fragment>
              <Text isConvertible={isConvertible} saleChannelUuid={uuid} />
              <Config saleChannelUuid={uuid} isConvertible={isConvertible} />
            </React.Fragment>
          );
        } else {
          return (
            <React.Fragment>
              <Text isConvertible={isConvertible} saleChannelUuid={uuid} />
              <Config saleChannelUuid={uuid} isConvertible={isConvertible} />
            </React.Fragment>
          );
        }
      }
    }
    return null;
  }, [
    isOnPrimaryLanguage,
    loaded,
    currentStyle,
    currentSize,
    uuid,
    translationEnabled,
  ]);

  return (
    <React.Fragment>
      <RouteBlock getHasModified={getHasModified} />
      <PageWrapper
        customHeader={
          <Header
            topRight={
              <Right
                onSaveDisable={!edit_maintenance_page}
                rarePart={
                  <CollapseIcon collapsed={collapsed} onChange={setCollapsed} />
                }
                hasModified={hasModified}
                onSubmit={() => {
                  const { submitFunction, isDataValid } = submit() || {};
                  if (isDataValid && submitFunction) {
                    submitFunction();
                  } else {
                    modal.error({
                      title: 'Errors',
                      content: 'This page has error',
                      onCancel: () => {
                        return;
                      },
                      onCancelText: getI18n('general.cancel'),
                      onOk: () => {
                        submitFunction();
                      },
                      okText: getI18n('general.save'),
                    });
                  }
                }}
                onDiscard={() => {
                  _h.push(`/salesChannel/content/${uuid}`);
                }}
                onChangeTranslation={handleOnTranslate}
                translationEnabled={translationEnabled}
                translationLoading={translationLoading}
                isOnPrimaryLanguage={isOnPrimaryLanguage}
                currentStyle={currentStyle}
              />
            }
            afterHeader={<TranslationTip />}
            afterHeaderCondition={
              translationEnabled &&
              !isOnPrimaryLanguage &&
              currentStyle === WebSiteSubType.NativeMobile
            }
          />
        }
        headerProps={{
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          height: 'min-content',
        }}
        headerConfig={{
          hasModified,
          salesChannelContentData: {},
          salesChannelName: 'test',
          handleOnTranslate,
          translationEnabled,
          translationLoading,
        }}
        leftChild={
          <PreviewStyleSwitch
            style={currentStyle}
            styleChild={
              <div
                style={{
                  height: 10000,
                  backgroundColor: 'transparent',
                  // margin: '0 auto',
                }}>
                123
              </div>
            }
            normalChild={
              <PreviewWrapper>
                <Spin spinning={loading}>
                  <PreviewContainer>
                    <Preview />
                  </PreviewContainer>
                </Spin>
              </PreviewWrapper>
            }
          />
        }
        rightChild={
          <RightConfigWrapper
            title={'Maintenance Page'}
            elements={[
              {
                body: Ele,
                key: 'Config',
              },
            ]}
          />
        }
        hideRightPart={collapsed}
      />
    </React.Fragment>
  );
}

export default SalesChannelHOC(
  BasicPageHOC(SalesChangeEditorMaintenancePage, {
    siteStyleInParams: true,
    previewSizeInParams: true,
    getState,
    convertDataFromReduxToServer,
    submit: request_submit,
    getHasModified,
    getSalesChannel: getSalesChannelContent,
    getSalesChannelName: getSalesChannelName,
    validation,
    getLoaded,
    queryData: (params, qParams) => {
      const { uuid } = params;
      dispatch(
        request_getMaintenancePage({
          uuid: uuid,
          params: qParams,
        }),
      );
    },
  }),
  { type: EnumMultiLanguageType.SalesChannelMaintenancePage },
);
